export const Types = {
    LIST_MEDICATIONS: "LIST_ADVERSE_EVENTS",
    MEDICATION_DETAILS: "ADVERSE_EVENT_DETAILS",
    GET_DOCTOR_NOTES:"GET_DOCTOR_NOTES",
    DOCTOR_NOTES_NOT_FOUND:"DOCTOR_NOTES_NOT_FOUND",
    MEDICATIONS_TYPES: "MEDICATIONS_TYPES"    
  };
